<template>

    <div class="row">
        <div class="col-sm-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Contactgegevens</h2>
                </div>
                <div class="box-body">
                    <vue-select-input
                        :label="lang.get('global.title')"
                        :error="errors.get('title')"
                        select-label="label"
                        :value="form.title_id"
                        :options="getAuth.settings.contacts.titles"
                        :reduce="type => type.value"
                        v-model="form.title_id"
                        :focus="true"
                    />
                    <text-input
                        :label="lang.get('global.firstname')"
                        :error="errors.get('firstname')"
                        v-model="form.firstname"
                    ></text-input>
                    <text-input
                        :label="lang.get('global.middlename')"
                        :error="errors.get('middlename')"
                        v-model="form.middlename"
                    ></text-input>
                    <text-input
                        :label="lang.get('global.lastname')"
                        :error="errors.get('lastname')"
                        v-model="form.lastname"
                    ></text-input>
                    <vue-select-input
                        :label="lang.get('global.type')"
                        select-label="label"
                        :error="errors.get('type_id')"
                        :value="form.type_id"
                        :options="getAuth.settings.contacts.types"
                        :reduce="type => type.value"
                        v-model="form.type_id"
                    />
                </div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Contactgegevens</h2>
                </div>
                <div class="box-body">
                    <text-input
                        :label="lang.get('global.mobile')"
                        :error="errors.get('mobile')"
                        v-model="form.mobile"
                    ></text-input>
                    <text-input
                        :label="lang.get('global.phone')"
                        :error="errors.get('phone')"
                        v-model="form.phone"
                    ></text-input>
                    <text-input
                        :label="lang.get('global.phone') + ' (alt)'"
                        :error="errors.get('phone_alt')"
                        v-model="form.phone_alt"
                    ></text-input>
                    <text-input
                        :label="lang.get('global.email')"
                        :error="errors.get('email')"
                        v-model="form.email"
                    ></text-input>
                    <text-input
                        :label="lang.get('global.email') + ' (alt)'"
                        :error="errors.get('email_alt')"
                        v-model="form.email_alt"
                    ></text-input>
                    <text-input
                        :label="lang.get('global.fax')"
                        :error="errors.get('fax')"
                        v-model="form.fax"
                    ></text-input>
                    <text-input
                        :label="lang.get('global.url')"
                        :error="errors.get('url')"
                        v-model="form.url"
                    ></text-input>
                </div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Adresgegevens</h2>
                </div>
                <div class="box-body">
                    <text-input
                        :label="lang.get('global.address')"
                        :error="errors.get('address')"
                        v-model="form.address"
                    ></text-input>
                    <text-input
                        :label="lang.get('global.zipcode')"
                        :error="errors.get('zipcode')"
                        v-model="form.zipcode"
                    ></text-input>
                    <text-input
                        :label="lang.get('global.city')"
                        :error="errors.get('city')"
                        v-model="form.city"
                    ></text-input>
                    <country-select
                        :label="lang.get('global.country')"
                        :error="errors.get('country_id')"
                        v-model="form.country_id"
                    ></country-select>
                </div>
            </div>

            <div class="text-right">
                <button
                    class="btn btn-primary"
                    :disabled="!canSubmit"
                    @click="onSubmit"
                >
                    {{ lang.get('global.save') }}
                </button>
            </div>
        </div>
    </div>

</template>

<script>

import Lang from "../../../Lang";
import Errors from "../../../Errors";
import TextInput from "../../../components/Common/Form/TextInput";
import SelectInput from "../../../components/Common/Form/VueSelectInput";
import CountrySelect from "../../../components/Common/Form/CountrySelect";
import { mapGetters } from "vuex";
import VueSelectInput from "../../../components/Common/Form/VueSelectInput.vue";

export default {

    components: {
        VueSelectInput,
        TextInput,
        SelectInput,
        CountrySelect,
    },

    computed: {
        ...mapGetters([
            'getAuth',
            'getContact',
        ]),

        canSubmit() {
            return this.posting === false &&
                (this.form.firstname !== '' ||
                this.form.lastname !== '');
        },

        getPostRoute() {
            return this.edit === true ?
                this.route('api.v1.crm.contacts.update', {uuid:this.getContact.uuid}) :
                this.route('api.v1.crm.contacts.store');
        },

        getPostData() {
            return this.form;
        },
    },

    data() {
        return {
            edit:false,
            errors:new Errors,
            form:{
                title_id: null,
                firstname:'',
                middlename:'',
                lastname:'',
                type_id: null,
                mobile:'',
                phone:'',
                phone_alt:'',
                email:'',
                email_alt:'',
                fax:'',
                url:'',
                address:'',
                zipcode:'',
                city:'',
                country_id:null,
            },
            lang:Lang,
            posting:false,
        }
    },

    metaInfo: {
        title:'Contact formulier',
    },

    methods: {

        checkForEdit() {
            if (!this.$route.params.uuid) {
                return;
            }

            this.form = JSON.parse(JSON.stringify(this.getContact));
            this.edit = true;
        },

        onSubmit() {
            if (!this.canSubmit) {
                return;
            }

            this.posting = true;
            axios.post(this.getPostRoute, this.getPostData)
                .then(resp => {
                    this.$snotify.success('De contactgegevens zijn aangepast');
                    this.resetData();
                    this.$emit('contactDataChanged');
                    this.$router.push({name:'crm.contacts.show', params:{uuid: resp.data.data.contact_uuid}});
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het opslaan van de contactgegevens'))
                .finally(() => this.posting = false);
        },

        resetData() {
            this.form = {
                title_id: null,
                firstname:'',
                middlename:'',
                lastname:'',
                type_id: null,
                mobile:'',
                phone:'',
                phone_alt:'',
                email:'',
                email_alt:'',
                fax:'',
                url:'',
                address:'',
                zipcode:'',
                city:'',
                country_id:null,
            };
            this.edit = false;
        },
    },

    mounted(){
        this.checkForEdit();
    },

    name: 'CrmContactsForm',

}

</script>
